import { UserStatusInterface, userStatusApiHandler } from '@api/userStatusApiHandler';
import { syncAdminPermissionsFromUserStatus } from '@helpers/adminPermissions.helper';
import { AppDispatch } from '../../hooks/useAppDispatch';
import { userStatusActions } from '../Slices/UserStatusSlice';

interface UpdateUserStatusPayload {
  isRegistered?: boolean;
  isJoined?: boolean | null;
  isEligibleForSpeakUpAlerts?: boolean | null;
  isOnboardCompleted?: boolean | null;
  isFirstShortStarCompleted?: boolean | null;
}

export const getUserStatusData = () => async (dispatch: AppDispatch) => {
  dispatch(userStatusActions.setLoading({ loading: true }));
  const token = localStorage.getItem('token');
  let response = null;

  try {
    response = token ? await userStatusApiHandler.getUserStatus() : null;
    const status =
      response?.responseObject ??
      (response && typeof response === 'object' && 'userId' in response
        ? (response as unknown as UserStatusInterface)
        : null);
    const user = localStorage.getItem('user');

    if (status && user) {
      syncAdminPermissionsFromUserStatus(status);

      dispatch(
        userStatusActions.updateUserStatus({
          isRegistered: status.isRegistered,
          isJoined: status.isJoined,
          isAgreed: JSON.parse(user).isAgree,
          isOnboardCompleted: status.isOnboardCompleted,
        }),
      );
    } else {
      dispatch(userStatusActions.setError({ error: 'Loading user status failed' }));
    }
  } catch (error) {
    dispatch(userStatusActions.setError({ error: 'Loading user status failed' }));
  }
};

export const updateUserStatusData =
  (data: UpdateUserStatusPayload) => async (dispatch: AppDispatch) => {
    dispatch(userStatusActions.setLoading({ loading: true }));

    try {
      const user = localStorage.getItem('user');
      const userId = user && JSON.parse(user).id;

      if (user && userId) {
        const response = await userStatusApiHandler.updateUserStatus(data);
        const updatedData = response.responseObject;

        dispatch(
          userStatusActions.updateUserStatus({
            isRegistered: updatedData.isRegistered,
            isJoined: updatedData.isJoined,
            isAgreed: JSON.parse(user).isAgree,
            isEligibleForSpeakUpAlerts: updatedData.isEligibleForSpeakupAlerts,
            isOnboardCompleted: updatedData.isOnboardCompleted,
            isFirstShortStarCompleted: updatedData.isFirstShortStarCompleted,
          }),
        );
      } else {
        dispatch(userStatusActions.setError({ error: 'Update user status failed' }));
      }
    } catch (error) {
      dispatch(userStatusActions.setError({ error: 'Update user status failed' }));
    } finally {
      dispatch(userStatusActions.setLoading({ loading: false }));
    }
  };
